import type { RecurrenceRule } from '../db/models'

export type RecurrenceTone = 'fixed' | 'after-done' | 'quota'

/**
 * Die Farbfamilie eines Mechanismus (CONTEXT.md, Wiederkehr-Wähler): der feste Rhythmus trägt
 * die Marke, „Nach Abhaken" Blau, die **Quote** Honig. Ein Name je Mechanismus, als BEM-Modifier
 * im Wähler, an der Marke der Seite Wiederkehrend und an der Pille der geöffneten Karte.
 */
export function recurrenceTone(rule: RecurrenceRule): RecurrenceTone {
  return rule.type === 'after_done' ? 'after-done' : rule.type === 'quota' ? 'quota' : 'fixed'
}
